<template>
  <transition name="fade" mode="out-in">
    <div class="col-span-full sm:col-span-full md:col-span-7 pb-4">
      <h1 class="text-t2 mb-4">Kontakta oss</h1>

      <Box v-if="submitted">
        <div class="text-t6 mb-2" v-html="webapp_config.msg.messages_submittedheading"></div>
        <div class="flex"><div class="text-b1">{{webapp_config.msg.messages_submittedtext}} <Button variant="text" class="!h-auto !p-0" @click="resetForm">Klicka här <IconArrowRightReg class="inline sm:ml-1 md:ml-2" /></Button></div></div>
      </Box>

      <template v-else>
      <div
        v-if="!isLoading && !!webapp_config.msg.messages_description"
        class="mb-4 rounded-[15px] bg-primary-10 p-4"
        v-html="webapp_config.msg.messages_description"
      ></div>

        <Box class="mb-8">
          <CardLoaderSmall v-if="isLoading" class="flex-1 sm:flex-wrap !p-0 !ring-0 space-b justify-between" />
          <div v-else>
            <p class="text-t6">Vad behöver du hjälp med?</p>

            <div v-if="!selectedOption" class="grid grid-cols-3 md:grid-cols-5 gap-4 mt-6">
              <IconButton
                v-for="category in categories"
                :key="category.value"
                type="button"
                @click="selectOption(category.value)"
                :state="previousSelection === category.value ? 'active' : 'default'"
              >
                {{ category.name }}
                <template #icon-after>
                  <component :is="iconMap[category.value] || 'IconQuestionmark'" />
                </template>
              </IconButton>
            </div>

            <div v-else class="mt-6">

              <div class="flex justify-between items-center gap-4">
                <p class="text-b1 flex items-center gap-2">
                  <component :is="selectedOptionIcon" class="inline-block" />
                  <span class="text-[14px]">{{ selectedOptionLabel }}</span>
                </p>
                <Button
                  variant="text"
                  size="small"
                  @click.prevent="changeSelection"
                >
                  Ändra
                </Button>
              </div>
            </div>

          </div>


      </Box>

      <Box v-if="selectedOption && isRedirectOption" class="mb-8">
        <p class="text-b1 mb-4 px-2 py-2 bg-turquoise-10 rounded-[4px]">{{ redirectOptions[selectedOption].text }}</p>
        <router-link :to="redirectOptions[selectedOption].route">
          <Button>
            {{ redirectOptions[selectedOption].buttonText }}
            <template #icon-after><IconArrowRight /></template>
          </Button>
        </router-link>
      </Box>

      <Box v-else-if="!selectedOption" class="mb-8" :disabled="true">
        <p class="text-t6">Vad handlar din fråga om?</p>
      </Box>

      <Box v-if="selectedOption && !isRedirectOption" class="mb-8">
        <p class="text-t6">{{ subjectHeading }}</p>

        <div v-if="optionsLoading" class="mt-4 flex items-center gap-2 text-b2 text-gray-60">
          <IconLoader />
          Laddar ämnen...
        </div>

        <SelectField
          v-if="options.length > 0"
          class="md:max-w-80 mt-4"
          id="key"
          placeholder=""
          :label=optionTitle
          :floatingLabel="true"
          :options="options.map(option => ({ label: option.name, value: option.id }))"
          v-model="question"
        />

        <div v-if="subOptionsLoading" class="mt-4 flex items-center gap-2 text-b2 text-gray-60">
          <IconLoader />
          Laddar underkategorier...
        </div>

        <SelectField
          v-else-if="subOptions.length > 1"
          class="md:max-w-80 mt-4"
          id="subkey"
          placeholder=""
          label="Välj underkategori"
          :floatingLabel="true"
          :options="subOptions.map(option => ({ label: option.name, value: option.id }))"
          v-model="subQuestion"
        />
      </Box>

      <Box v-if="selectedCategoryIsContract && contracts.length > 1 && (!selectedQuestionHasSubcategories || subQuestion)" class="mb-8">

        <div>
          <p class="text-t6 mb-4">Vilken adress gäller frågan?</p>
          <div v-if="!selectedContract" class="space-y-4">
            <RadioButton
              v-for="contract in contracts"
              :key="contract.value"
              :id="'contract-' + contract.value"
              name="selectedContract"
              v-model="selectedContract"
              :value="contract.value"
              :label="contract.name"
            />
          </div>
          <div v-else class="flex justify-between items-center gap-4 mt-4">
            <span class="text-[14px]">{{ selectedContractLabel }}</span>
            <Button variant="text" size="small" @click.prevent="changeContract">
              Ändra
            </Button>
          </div>
        </div>
        </Box>

        <Box v-if="selectedOption && !isRedirectOption && !optionsLoading && (options.length === 0 || (question && (!selectedQuestionHasSubcategories || subQuestion))) && (!selectedCategoryIsContract || contracts.length <= 1 || selectedContract)" class="mb-8">
          <div>
          <label for="description" class="text-t6 mb-2 block leading-[149%]">Beskriv vad vi kan hjälpa dig med</label>
          <textarea
            name="description"
            v-model="description"
            maxlength="750"
            rows="8"
            placeholder="Skriv din fråga eller fundering"
            autocomplete="off"
            class="w-full rounded-[8px] p-2 ring-1 ring-gray-60 focus:!ring-[#2c3e50] focus:outline-none focus-visible:outline-none focus-visible:!ring-[#2c3e50]"
          />

          <div class="text-b2 mt-6 rounded-[4px] bg-primary-10 py-2 px-4 mb-4">
            <p v-if="defaultPhone">
              Vi svarar dig på {{profile.email}} eller {{ defaultPhone }}. Har du andra kontaktuppgifter? <a @click="showModal=true">Uppdatera dina kontaktuppgifter</a>
            </p>
            <p v-else>
              Vi svarar dig på {{profile.email}}. Har du andra kontaktuppgifter? <a @click="showModal=true">Uppdatera dina kontaktuppgifter</a>
            </p>
          </div>
        </div>

        <Modal
          size="sm"
          v-if="showModal"
          :hideFooterDivider="true"
          :headingDivider="false"
          :showContact="false"
          loadingText="Sparar.."
          :headingLarge="true"
          secondaryButtonStyle="tertiery"
          @cancel="showModal=false"
          header="Uppdatera kontaktuppgifter"
          :hasClose="false"
          @done="showModal=false"
          >
          <section>
            <ContactInfoForm :profile="profile" :editProfilePreset="true" @done="onContactInfoSaved" />
          </section>
        </Modal>

        <div class="pt-4 border-t border-solid border-gray-light" v-if="!optionsLoading">
          <Button :loading="isSending" loadingText="Skickar.." :disabled="!description || description.length < 3" @click="submitMessage">Skicka</Button>
        </div>
      </Box>

      </template>

    </div>
  </transition>
</template>

<script>
import { axios_legacy as axios, axios as axios_new_api } from '@/store/config';
import { mapGetters } from 'vuex';
import Box from '@/components/ui/box';
import IconButton from '@/components/ui/iconbutton';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';
import IconHouseCircle from '@/components/icons/IconHouseCircle';
import IconHouseBlank from '@/components/icons/IconHouseBlank';
import IconHouse from '@/components/icons/IconHouse';
import IconFullmakt from '@/components/icons/IconFullmakt';
import IconWebpage from '@/components/icons/IconWebpage';
import IconTools from '@/components/icons/IconTools';
import IconLaundry from '@/components/icons/IconLaundry';
import IconDoor from '@/components/icons/IconDoor';
import IconSpeechBubble from '@/components/icons/IconSpeechBubble';
import IconQuestionmark from '@/components/icons/IconQuestionmark';
import IconInvoice from '@/components/icons/IconInvoice';
import RadioButton from '@/components/ui/form/radioAlt';
import Button from '@/components/ui/button';
import SelectField from '@/components/ui/form/select';
import ContactInfoForm from '@/components/profile/contact-info-form'
import Modal from '@/components/ui/modal'
import IconArrowRight from '@/components/icons/IconArrowRight';
import IconLoader from '@/components/icons/IconLoader';
import IconArrowRightReg from '@/components/icons/IconArrowRightReg'

export default {
  name: 'messages',
  mixins: [],
  components: {
    Box,
    CardLoaderSmall,
    IconButton,
    IconHouseCircle,
    IconHouseBlank,
    IconHouse,
    IconTools,
    IconLaundry,
    IconDoor,
    IconSpeechBubble,
    IconQuestionmark,
    IconInvoice,
    IconFullmakt,
    IconWebpage,
    RadioButton,
    Button,
    SelectField,
    ContactInfoForm,
    Modal,
    IconArrowRight,
    IconLoader,
    IconArrowRightReg
  },
  data() {
    return {
      isLoading: false,
      isSending: false,
      submitted: false,
      selectedOption: null,
      previousSelection: null,
      selectedContract: null,
      description: null,
      question: null,
      subQuestion: null,
      options: [],
      optionsLoading: false,
      subOptions: [],
      subOptionsLoading: false,
      leases: [],
      categoryType: null,
      categoryIsContract: false,
      requiredLeaseType: null,
      categories: [],
      showModal: false,
      iconMap: {
        myResidence: 'IconHouseCircle',
        rental: 'IconDoor',
        opinion: 'IconSpeechBubble',
        pestControl: 'IconQuestionmark',
        economic: 'IconInvoice',
        powerOfAttorney: 'IconFullmakt',
        myPages: 'IconWebpage',
        felanmalan: 'IconTools',
        tillval: 'IconLaundry',
      },
      redirectOptions: {
        felanmalan: {
          route: '/felanmalan/skapa',
          text: 'Gå till felanmälan för att anmäla ett fel i din bostad eller i gemensamma utrymmen.',
          buttonText: 'Anmäl ett fel',
        },
        tillval: {
          route: '/tillval',
          text: 'Gå till tillval för att se och beställa tillval till din bostad.',
          buttonText: 'Till tillval',
        },
      },
    };
  },
  computed: {
    ...mapGetters(["webapp_config", "profile", "hasActiveResidentalContract"]),
    defaultPhone() {
      if (this.profile && this.profile.defaultPhone) return this.profile.phoneMobile;
    },
    selectedOptionLabel() {
      const category = this.categories.find(c => c.value === this.selectedOption);
      return category?.name || '';
    },
    selectedOptionIcon() {
      return this.iconMap[this.selectedOption] || 'IconQuestionmark';
    },
    contracts() {
      return this.leases;
    },
    isRedirectOption() {
      return !!this.redirectOptions[this.selectedOption];
    },
    selectedCategoryIsContract() {
      return this.categoryIsContract;
    },
    subjectHeading() {
      if (this.selectedOption === 'pestControl') return 'Vilket utrymme är drabbat?';
      return 'Vad handlar din fråga om?';
    },
    optionTitle() {
      if (this.selectedOption === 'pestControl') return 'Välj utrymme';
      return 'Välj ämne';
    },
    selectedContractLabel() {
      if (!this.selectedContract) return '';
      const contract = this.contracts.find(c => c.value === this.selectedContract);
      return contract?.name || this.selectedContract;
    },
    selectedQuestionHasSubcategories() {
      if (!this.question) return false;
      return this.options.find(o => o.id === this.question)?.hasSubcategories || false;
    }

  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.submitted) vm.resetForm();
    });
  },
  created() {
    // Skrolla alltid till toppen
    window.scroll(0, 0);

    this.isLoading = true;

    axios_new_api.get('/workorders/questions/categories').then((response) => {
      const extra = this.hasActiveResidentalContract
        ? [{ name: 'Felanmälan', value: 'felanmalan' }, { name: 'Tillval', value: 'tillval' }]
        : [];
      this.categories = [...response.data, ...extra];
    }).finally(() => {
      this.isLoading = false;
    });
  },


  watch: {
    selectedOption(value) {
      this.question = null;
      this.subQuestion = null;
      this.options = [];
      this.subOptions = [];
      this.categoryIsContract = false;
      this.requiredLeaseType = null;
      this.leases = [];
      this.selectedContract = null;
      this.description = null;
      if (!value) return;
      this.categoryType = value;
      this.optionsLoading = true;
      axios_new_api.get(`/workorders/questions/categories/${value}`).then((response) => {
        const data = response.data || [];
        this.options = data.map(item => ({
          name: item.name,
          value: item.value,
          id: item.id,
          hasSubcategories: item.hasSubcategories,
          isContractCategory: item.isContractCategory,
          categoryType: item.categoryType
        }));

        if (this.options.length === 1) {
          this.question = this.options[0].id;
        }

        // Check if any option requires a contract
        const contractOption = data.find(item => item.isContractCategory);
        if (contractOption) {
          this.categoryIsContract = true;
          this.requiredLeaseType = contractOption.categoryType;
          this.fetchLeases(contractOption.categoryType);
        }
      }).finally(() => {
        this.optionsLoading = false;
      });
    },
    question(value) {
      this.subQuestion = null;
      this.subOptions = [];
      this.subOptionsLoading = false;
      this.selectedContract = null;
      this.description = null;
      this.categoryIsContract = this.options.some(o => o.isContractCategory);
      if (!value) return;

      const selected = this.options.find(o => o.id === value);

      // Update contract requirement if this specific option has it
      if (selected?.isContractCategory && selected?.categoryType) {
        this.categoryIsContract = true;
        this.requiredLeaseType = selected.categoryType;
        if (this.leases.length === 0) {
          this.fetchLeases(selected.categoryType);
        }
      }

      if (!selected?.hasSubcategories) return;

      this.subOptionsLoading = true;
      axios_new_api.get(`/workorders/questions/categories/${value}/subcategories`).then((response) => {
        if (this.question !== value) return;
        const data = response.data || [];
        this.subOptions = data.map(item => ({
          name: item.name,
          value: item.value,
          id: item.id,
          hasSubcategories: item.hasSubcategories,
          isContractCategory: item.isContractCategory,
          categoryType: item.categoryType
        }));

        if (data.length === 1) {
          this.subQuestion = data[0].id;
        }

        // Check if subcategories require a contract
        const contractSubOption = data.find(item => item.isContractCategory);
        if (contractSubOption) {
          this.categoryIsContract = true;
          this.requiredLeaseType = contractSubOption.categoryType;
          if (this.leases.length === 0) {
            this.fetchLeases(contractSubOption.categoryType);
          }
        }
      }).finally(() => {
        this.subOptionsLoading = false;
      });
    },
    subQuestion(value) {
      if (!value) return;

      const selected = this.subOptions.find(o => o.id === value);

      // Update contract requirement if this specific sub-option has it
      if (selected?.isContractCategory && selected?.categoryType) {
        this.categoryIsContract = true;
        this.requiredLeaseType = selected.categoryType;
        if (this.leases.length === 0) {
          this.fetchLeases(selected.categoryType);
        }
      }
    }
  },
  methods: {
    fetchLeases(leaseType) {
      if (!leaseType) return;

      axios_new_api.get(`/workorders/questions/leases/${leaseType}`)
        .then((response) => {
          this.leases = response.data || [];

          // Auto-select if only one lease
          if (this.leases.length === 1) {
            this.selectedContract = this.leases[0].value;
          }
        })
        .catch((error) => {
          console.error('Error fetching leases:', error);
          this.leases = [];
        });
    },
    selectOption(option) {
      this.selectedOption = option;
      this.previousSelection = option;
      this.selectedContract = null;

      const category = this.categories.find(c => c.value === option);
      if (category?.isContractCategory && this.contracts.length === 1) {
        this.selectedContract = this.contracts[0].value;
      }
    },
    changeSelection() {
      this.selectedOption = null;
      this.selectedContract = null;
    },
    changeContract() {
      this.selectedContract = null;
    },
    onContactInfoSaved() {
      this.showModal = false;
      this.$store.dispatch('fetchProfile');
    },
    resetForm() {
      this.submitted = false;
      this.selectedOption = null;
      this.previousSelection = null;
      this.selectedContract = null;
      this.description = null;
      this.question = null;
      this.subQuestion = null;
      this.options = [];
      this.subOptions = [];
      this.leases = [];
      this.categoryType = null;
      this.categoryIsContract = false;
      this.requiredLeaseType = null;
      window.scroll(0, 0);
    },
    submitMessage() {
      this.isSending = true;
      const payload = {
        categoryType: this.categoryType,
        mainCategoryId: this.question,
        subCategoryId: this.subQuestion || null,
        rentalObjectId: this.selectedContract && this.selectedContract !== "Ingen adress" ? this.selectedContract : null,
        description: this.description,
      };
      axios_new_api.post('/workorders/questions', payload)
        .then(() => {
          this.submitted = true;
        })
        .catch(() => {
          // handle error
        })
        .finally(() => {
          this.isSending = false;
        });
    },
  },
};
</script>

